import { useCallback } from 'react';
import { ts } from '../api';
import { Page, useTS } from '../ui';
import PhoneMenuEditor from '../../components/PhoneMenuEditor';

export default function TSPhoneMenu() {
  const session = useTS();
  const main = session.company?.main_number_e164 || '';
  const load = useCallback(() => ts.phoneMenu(), []);
  const pretty = main.replace(/^\+1(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
  return (
    <Page title="Phone Menu" subtitle={'Set up "press 1 for…, press 2 for…" on your main number. Changes apply to the next call.'}>
      <PhoneMenuEditor load={load} save={ts.savePhoneMenu} preview={ts.previewPhoneMenu}
        numberLabel={pretty ? `your main number ${pretty}` : 'your main number'} />
    </Page>
  );
}
